import { onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { leagueSettingsRef, requireLeagueOrgId } from "./leagueRepository";

export const VOCABULARY_PRESETS = Object.freeze([
  { key: "sites", singular: "Site", plural: "Sites" },
  { key: "stores", singular: "Store", plural: "Stores" },
  { key: "branches", singular: "Branch", plural: "Branches" },
  { key: "clinics", singular: "Clinic", plural: "Clinics" },
  { key: "warehouses", singular: "Warehouse", plural: "Warehouses" },
  { key: "offices", singular: "Office", plural: "Offices" },
  { key: "campuses", singular: "Campus", plural: "Campuses" },
  { key: "plants", singular: "Plant", plural: "Plants" },
  { key: "depots", singular: "Depot", plural: "Depots" },
]);
export const DEFAULT_LEAGUE_VOCABULARY = Object.freeze({ preset:"sites", singular:"Site", plural:"Sites", customOptions:[] });
export function normalizeLeagueVocabulary(value={}) {
  const singular=String(value.singular||"Site").trim()||"Site";
  const plural=String(value.plural||`${singular}s`).trim()||`${singular}s`;
  return { preset:String(value.preset||"custom").trim().toLowerCase(), singular, plural, customOptions:Array.isArray(value.customOptions)?value.customOptions:[] };
}
export function subscribeLeagueVocabulary(orgId,onValue,onError){return onSnapshot(leagueSettingsRef(requireLeagueOrgId(orgId)),s=>onValue(normalizeLeagueVocabulary(s.exists()?s.data()?.vocabulary:{})),onError)}
export async function saveLeagueVocabulary(orgId,vocabulary){
  const safe=requireLeagueOrgId(orgId); const normalized=normalizeLeagueVocabulary(vocabulary);
  const customs=[...(normalized.customOptions||[])];
  if(normalized.preset==="custom" && normalized.singular && normalized.plural && !customs.some(x=>x.singular.toLowerCase()===normalized.singular.toLowerCase())) customs.push({key:`custom-${Date.now()}`,singular:normalized.singular,plural:normalized.plural});
  const payload={...normalized,customOptions:customs};
  await setDoc(leagueSettingsRef(safe),{vocabulary:payload,updatedAt:serverTimestamp()},{merge:true}); return payload;
}
